import { useRouter } from "next/router";
import type { FunctionComponent } from "react";
import { useEffect } from "react";

import { SanitizedUrlKeys } from "scmp-app/components/popup-container/onboarding/consts";
import { useRouterReplaceWithSanitizedKeys } from "scmp-app/lib/router/hooks";

import { useSubscriberOnboarding } from "./hooks";

export const SubscriberOnboarding: FunctionComponent = () => {
  const { pathname, query } = useRouter();
  const replace = useRouterReplaceWithSanitizedKeys();

  const { subscriberOnboardingService } = useSubscriberOnboarding();

  useEffect(() => {
    if (!subscriberOnboardingService) return;
    subscriberOnboardingService?.addOnboardingScript();
    void replace(
      SanitizedUrlKeys,
      { pathname, query },
      {
        shallow: true,
      },
    );
    return;
  }, [pathname, query, replace, subscriberOnboardingService]);

  return null;
};
